import { createAction, props } from '@ngrx/store';
import { Depot } from '../../../shared/models/depot.interface';
import { ExternalCredentials } from '@por/shared/core';

export enum OrganizationActionTypes {
    LoadDepots = '[Organization] Load Depots',
    LoadDepotsSuccess = '[Organization] Load Depots Success',
    LoadDepotsFailure = '[Organization] Load Depots Failure',
    LoadExternalCredentials = '[Organization] Load External Credentials',
    LoadExternalCredentialsSuccess = '[Organization] Load External Credentials Success',
    LoadExternalCredentialsFailure = '[Organization] Load External Credentials Failure'
}

export const loadDepots = createAction(OrganizationActionTypes.LoadDepots, props<{ organizationId: string }>());

export const loadDepotsSuccess = createAction(OrganizationActionTypes.LoadDepotsSuccess, props<{ depots: Depot[] }>());

export const loadDepotsFailure = createAction(OrganizationActionTypes.LoadDepotsFailure, props<{ error: string }>());

export const loadExternalCredentials = createAction(OrganizationActionTypes.LoadExternalCredentials, props<{ organizationId: string }>());

export const loadExternalCredentialsSuccess = createAction(OrganizationActionTypes.LoadExternalCredentialsSuccess, props<{ externalCredentials: ExternalCredentials[] }>());

export const loadExternalCredentialsFailure = createAction(OrganizationActionTypes.LoadExternalCredentialsFailure, props<{ error: string }>());
